import React from 'react'

function CandidateConversation() {
  return (
    <div>CandidateConversation</div>
  )
}

export default CandidateConversation